export default function Tickets() {
  return (
    <div>
      <h1 className="page-title">Tickets page</h1>
    </div>
  );
}
